const DENIED_REASONS = {
    PAGE_PERMISSION_NOT_GRANTED: {
        title: '你还不能访问这个页面',
        description: '你暂未获得该页面权限，请联系应用负责人授权。',
    },
    PAGE_NOT_REGISTERED: {
        title: '这个页面还没有接入权限管理',
        description: '该页面尚未纳入访问配置，请联系应用负责人重新同步页面。',
    },
    PAGE_CATALOG_UNSYNCED: {
        title: '应用还没有完成页面接入',
        description: '应用负责人尚未同步页面清单，请联系负责人处理后再试。',
    },
    PARTNER_ACCESS_NOT_CONFIGURED: {
        title: '应用还没有开放给其他伙伴',
        description: '应用负责人尚未配置伙伴访问权限，请联系负责人授权后再试。',
    },
}

const DEFAULT_DENIED_REASON = {
    title: '你还不能访问这个页面',
    description: '当前访问未通过页面权限校验，请联系应用负责人确认访问权限。',
}

export const getDeniedReasonContent = reason => DENIED_REASONS[reason] || DEFAULT_DENIED_REASON

export const shouldPromptRouteResync = reason => reason === 'PAGE_NOT_REGISTERED'

const ROUTE_SETUP_REASONS = new Set(['PAGE_NOT_REGISTERED', 'PAGE_CATALOG_UNSYNCED'])

export const getDeniedReasonAction = reason => ROUTE_SETUP_REASONS.has(reason)
    ? {
        requestLabel: '提醒负责人处理',
        submittedLabel: '已提醒负责人',
        guideTitle: '等待负责人完成页面接入',
        steps: ['发送提醒，通知应用负责人同步页面清单。', '负责人处理后，等待约 30 秒再重新检查。'],
    }
    : {
        requestLabel: '申请访问权限',
        submittedLabel: '申请已发送',
        guideTitle: '申请应用访问权限',
        steps: ['提交申请，系统会通过钉钉提醒应用负责人。', '负责人授权后，等待约 30 秒再重新检查。'],
    }

export const buildAccessRequestText = ({ projectName, ownerUserNick, requestId }) => {
    const owner = ownerUserNick ? `负责人：${ownerUserNick}。` : ''
    const trace = requestId ? `排查编号：${requestId}。` : ''
    return `我需要访问 Vibe 应用「${projectName || '当前应用'}」，当前提示暂无页面权限。${owner}请在 AMS 应用权限设置中为我授权。${trace}`
}
